export const DEBUG: boolean = true;
export const PRODUCTION: boolean = true;
export const TESTING: boolean = true;
export const IS_RECORDING: boolean = true;
export const IS_CI: boolean = true;
export const SHOULD_RECORD: boolean = true;
